"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _layers = require("@site/pattern-library-utils/layers");
var _tracking = _interopRequireWildcard(require("@site/pattern-library-utils/tracking"));
var _domainSearch = _interopRequireDefault(require("@site/pattern-library-core/domain-search"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _text = _interopRequireDefault(require("@ux/text"));
var _button = _interopRequireDefault(require("@ux/button"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SearchContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SearchContainer",
  class: "pl-s1uteo25"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconWrapper",
  class: "pl-i1bvshwe"
});
const TldIndicator = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TldIndicator",
  class: "pl-t1a0mg9d"
});
const CloseButton = /*#__PURE__*/(0, _react2.styled)(_button.default)({
  name: "CloseButton",
  class: "pl-c1hvxgyu"
});
const TldButtons = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TldButtons",
  class: "pl-tqia3ky"
});

/**
 * DomainSearchBar Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Component ID
 * @param {Object} props.domainSearch Domain search properties
 * @param {String} props.partial Partial name
 * @param {Array} props.tlds Array of TLD objects with text property
 * @param {String} props.tldMoreButtonText Text for the more button
 * @param {String} props.tldMoreButtonUrl URL for the more button
 * @param {String} props._name Component tracking name for generating unique button tracking names
 * @param {Boolean} props.isOverlayElevated Whether the TLD indicator should have elevated z-index for overlay visibility
 * @returns {React.ReactElement} DomainSearchBar Component
 * @public
 */

function DomainSearchBar({
  id,
  _name = 'domain-search-bar',
  domainSearch,
  partial = '',
  tlds,
  tldMoreButtonText = 'More',
  tldMoreButtonUrl,
  isOverlayElevated = false
}) {
  const [selectedTld, setSelectedTld] = (0, _react.useState)(null);
  const closeButtonRef = (0, _react.useRef)();
  const moreButtonRef = (0, _react.useRef)();
  (0, _tracking.useTracking)(closeButtonRef);
  (0, _tracking.useTracking)(moreButtonRef);
  const domainSearchStyles = {
    buttonColor: _intents.default.ux.actionPrimary.backgroundColor,
    buttonColorHover: _intents.default.ux.actionPrimaryHovered.backgroundColor,
    color: _intents.default.ux.actionPrimary.foregroundColor
  };
  const handleTldSelect = (0, _react.useCallback)(tld => {
    if (selectedTld?.text === tld.text) {
      setSelectedTld(null);
    } else {
      setSelectedTld(tld);
    }
  }, [selectedTld]);
  const handleRemoveTld = (0, _react.useCallback)(() => {
    setSelectedTld(null);
  }, []);
  const handleTldKeyDown = (0, _react.useCallback)((e, tld) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleTldSelect(tld);
    }
  }, [handleTldSelect]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SearchContainer, {
    className: "input-wrapper",
    "data-partial": "boxRadiusLarge"
  }, /*#__PURE__*/_react.default.createElement(IconWrapper, {
    "data-cy": "search-icon",
    className: "search-icon"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "search",
    height: 24,
    width: 24
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "search-container",
    "data-partial": partial
  }, /*#__PURE__*/_react.default.createElement(_domainSearch.default, (0, _extends2.default)({
    id: id
  }, domainSearch, {
    styling: domainSearchStyles,
    "data-partial": partial,
    selectedTld: selectedTld?.text
  }))), tlds && /*#__PURE__*/_react.default.createElement(TldIndicator, {
    className: (0, _core.cx)('tld-indicator', selectedTld && 'visible', isOverlayElevated && 'overlay-elevated')
  }, selectedTld && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 1,
    className: "tld-text",
    text: selectedTld.text
  }), /*#__PURE__*/_react.default.createElement(CloseButton, (0, _extends2.default)({
    "data-cy": "close",
    design: "stateless",
    "aria-label": "remove-tld",
    icon: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "delete"
    }),
    onClick: handleRemoveTld,
    ref: closeButtonRef
  }, _tracking.default.props(`close-button-${selectedTld.text}`, true, true)))))), tlds && /*#__PURE__*/_react.default.createElement(TldButtons, {
    "data-cy": "tld-buttons",
    className: "tld-buttons"
  }, tlds.map((tld, index) => /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    id: `${id}-tld-button-${tld.text}`,
    key: index,
    className: selectedTld?.text === tld.text ? 'selected' : '',
    onClick: () => handleTldSelect(tld),
    role: "button",
    tabIndex: 0,
    onKeyDown: e => handleTldKeyDown(e, tld),
    "aria-label": `Select ${tld.text} domain extension`
  }, _tracking.default.props(`${_name}-tld-button-${tld.text}`, true, true)), /*#__PURE__*/_react.default.createElement(_button.default, {
    text: tld.text,
    size: "md",
    tabIndex: -1
  }), tld.price && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "label",
    className: "tld-price",
    text: tld.price
  }), tld.tagLabel && /*#__PURE__*/_react.default.createElement(_tag.default, {
    text: tld.tagLabel,
    design: tld.labelDesign,
    size: "sm"
  }))), tldMoreButtonUrl && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    role: "button",
    className: "more-button",
    tabIndex: 0,
    "aria-label": "view more",
    ref: moreButtonRef
  }, _tracking.default.props(`${_name}-more-button`, true, true)), /*#__PURE__*/_react.default.createElement(_button.default, {
    text: `+ ${tldMoreButtonText}`,
    size: "small",
    tabIndex: -1,
    href: tldMoreButtonUrl
  }))));
}
var _default = exports.default = DomainSearchBar;
DomainSearchBar.propTypes = {
  id: _propTypes.default.string,
  partial: _propTypes.default.string,
  domainSearch: _propTypes.default.shape(_domainSearch.default.propTypes),
  tlds: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string.isRequired
  })),
  tldMoreButtonText: _propTypes.default.string,
  tldMoreButtonUrl: _propTypes.default.string,
  _name: _propTypes.default.string,
  isOverlayElevated: _propTypes.default.bool
};